import React, { useState, useEffect } from "react";
import { getAccessTokenApi ,getRefreshTokenApi,getPublicIP} from "../../../api/auth";
import { getUsersActiveApi, Keyrock } from "../../../api/user";
import ListUsers from "../../../components/Admin/Users/ListUsers";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import { message, Upload,Form, Input, Button,Checkbox,Divider ,notification,TreeSelect  ,Col, InputNumber, Row, Slider, Space ,Switch} from "antd";
import Logo from "../../../assets/img/png/logo-white.png";
import {post} from "../../../api/post";
import {get} from "../../../api/get";

import "./Instructions.scss";

export default function Contacto() {
  const [usersActive, setUsersActive] = useState([]); //Todos los usuarios
  const [usersInactive, setUsersInactive] = useState([]);
  const [reloadUsers, setReloadUsers] = useState(false);
  const [form] = Form.useForm();

  const token = getAccessTokenApi();



  const onFinish = (values) => {
    // console.log('Formulario enviado:', values);
    const data={
      comment:values.comment,
      email: values.email,
      name: values.name
    }
    console.log('Formulario enviado:', data);
    post(data,'contact','contact','');
    message.success('Comment sended!')
    form.resetFields();
  };


  useEffect(() => {
    get(`users-active?active=${true}`,'users-active','').then((response) => {
      // getUsersActiveApi(token, true).then((response) => {
        //console.log(response);
        setUsersActive(response.users);
      });
    get(`users-active?active=${false}`,'users-active','').then((response) => {
    // getUsersActiveApi(token, false).then((response) => {
      setUsersInactive(response.users);
    });

    setReloadUsers(false);
  }, [token, reloadUsers]); //Solo se refresca si cambian estos

  return (
    <>
    <div className="instructionsContacto">
        <div className="instructionsContacto-up">
            <a href="/" className="instructionsContacto-up-pictureAndLogo-logo">
              <img src={Logo} alt="logo" />
            </a>
          <div className="margCon">
            <h2 style={{color:'white'}}>Contact Us</h2>

            <p style={{color:'white'}}>We'd love to hear from you! If you have any questions, feedback, or inquiries, please feel free to get in touch with us. You can use the contact form below to send us a message, and we'll get back to you as soon as possible.</p>

            <h2 style={{color:'white'}}>Contact Information</h2>

            <p style={{color:'white'}}><strong>Email:</strong> project@capillar.it</p>
            
          </div>
        </div>
      <div className="contactoContainer">
        <Form
        form={form}
          name="comment-form"
          onFinish={onFinish}
          layout="vertical"
          style={{ width: '100%' }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter your name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter your email address' },
              { type: 'email', message: 'Please enter a valid email address' }
            ]}
            style={{ flex: 1 }}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Comment"
            name="comment"
            rules={[{ required: true, message: 'Please enter your comment' }]}
            style={{ flex: 1 }}
          >
            <Input.TextArea style={{ minHeight: '170px' }}/>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Send Comment
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
    </>
  );
}
